import React from 'react'

function Aboutbutton() {
  return (
    <>
      <span className='btn_div'>
        <button type='button' className='details_btn btn btn-group-sm bg-slate-950'> Details</button>
      </span>
    </>
  )
}

export default Aboutbutton;
